import Element from './Element';

export default class SideMenuSectionCard extends Element {
    public create(params: any): void {
        super.create({
            type: 'group',
            name: 'cards_section',
            layout: {
                anchors: [0, 0, 1, 0],
                pivot: [0.5, 0],
                offsets: [0, 0, 0, 0],
            },
            components: [
                {
                    type: 'scroll',
                    data: {
                        friction: 0.9,
                        direction: 'y',
                    },
                },
                {
                    type: 'mask',
                    data: {
                        offset: [0, 12, 0, 24],
                    },
                },
            ],
            children: [
                {
                    type: 'group',
                    name: 'title',
                    layout: {
                        anchors: [0, 0, 1, 0],
                        pivot: [0.5, 0],
                        offsets: [0, -30, 0, -30],
                    },
                    components: [
                        {
                            type: 'text',
                            data: {
                                textLocalizationKey: 'CardDesignCollection',
                                style: {
                                    font: 'RussoOne',
                                    fill: '#fff',
                                    fontSize: '40px',
                                    stroke: '#C27E54',
                                    strokeThickness: 6,
                                },
                                align: 'center',
                                bounds: [500, 200],
                            },
                        },
                    ],
                },
                {
                    type: 'group',
                    name: 'cards_list',
                    layout: {
                        anchors: [0, 0, 1, 0],
                        pivot: [0.5, 0],
                        offsets: [0, 0, 0, 0],
                    },
                    components: [
                        {
                            type: 'verticalgroup',
                            data: {
                                padding: [0, 100, 0, 40],
                                spacing: 40,
                            },
                        },
                    ],
                },
            ],
            ...params,
        });
    }
}
